/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import GuardianRouteLinkItem from './GuardianRouteLinkItem';
import LanguageCitizenshipIcon from 'icons/LanguageCitizenshipIcon';

const messages = defineMessages({
  title: {id: 'navigation.language-citizenship'},
});

const LanguageCitizenshipItem = () => (
  <GuardianRouteLinkItem
    iconBefore={LanguageCitizenshipIcon}
    route="midas/guardian/language-citizenship"
    title={messages.title}
  />
);

export default LanguageCitizenshipItem;
